/**
 * @generated SignedSource<<a6a57076810cab259fbfce49c9bee33f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateUserPromptsInput = {
  clientMutationId?: string | null | undefined;
  userPrompts?: ReadonlyArray<UpdateUserPromptsRecordInput | null | undefined> | null | undefined;
};
export type UpdateUserPromptsRecordInput = {
  answer?: string | null | undefined;
  promptId?: any | null | undefined;
};
export type useUserPromptsMutation$variables = {
  input: UpdateUserPromptsInput;
};
export type useUserPromptsMutation$data = {
  readonly updateUserPrompts: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useUserPrompts_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useUserPromptsMutation = {
  response: useUserPromptsMutation$data;
  variables: useUserPromptsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserPromptsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserPromptsPayload",
        "kind": "LinkedField",
        "name": "updateUserPrompts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useUserPrompts_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUserPromptsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserPromptsPayload",
        "kind": "LinkedField",
        "name": "updateUserPrompts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "UserPromptConnection",
                    "kind": "LinkedField",
                    "name": "userPrompts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserPrompt",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "promptId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "answer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Prompt",
                            "kind": "LinkedField",
                            "name": "prompt",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "question",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "deletedAt",
                                "storageKey": null
                              },
                              (v2/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "userPrompts(orderBy:[\"SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "614c785d7703c396c38cf57d2306a7df",
    "id": null,
    "metadata": {},
    "name": "useUserPromptsMutation",
    "operationKind": "mutation",
    "text": "mutation useUserPromptsMutation(\n  $input: UpdateUserPromptsInput!\n) {\n  updateUserPrompts(input: $input) {\n    query {\n      ...useUserPrompts_query\n      id\n    }\n  }\n}\n\nfragment useUserPrompts_query on Query {\n  currentUser {\n    userPrompts(orderBy: [SEQUENCE_ASC]) {\n      nodes {\n        promptId\n        answer\n        prompt {\n          question\n          deletedAt\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "632d04f0906bc5ef311d924721d8f458";

export default node;
